<!-- 套餐详情页面 -->

<template>
    <div class="package-detail">
        <div class="package-detail-header" :style="headerBgImgStyle">
            <app-header            
                @on-click="goBack"
                opacity
                class="package-detail-header-box"
            ></app-header>
            <van-swipe :loop="false" class="package-detail-swiper">
                <van-swipe-item v-for="(image, index) in imageList" :key="index">
                    <img width="100%" height="100%" v-lazy="image" @click="handlerImagePreview(imageList,index)"/>
                </van-swipe-item>
                  <template #indicator>
                    <div></div>
                  </template>
            </van-swipe>
        </div>
        <div class="package-detail-box">
            <div class="package-base-info">
                <div class="goods-name">{{ detail.goodsName }}</div>
                <div class="goods-price" 
                v-if="detail.firstPrice">{{detail.firstShowPrice}}<i class="oprice"> {{ doPriceStyle(detail, detail.oringPrice) }}</i></div>
                <div class="goods-price" 
                v-else-if="detail.oringPrice">{{detail.showPrice}}<i class="oprice"> {{ doPriceStyle(detail, detail.oringPrice) }}</i></div>
                <div class="goods-price" v-else>{{detail.showPrice }}</div>
                <!-- <div class="info-box van-hairline--top"> -->
                    <!-- saas-隐藏流量-配置 -->
                    <!-- <van-cell :title="$t('packages.detail.cell_flow')" 
                    value-class="flex2"
                    v-if="!detail.extendValVos || !detail.a_getValue_hideFlowSize || detail.a_getValue_hideFlowSize && detail.a_getValue_hideFlowSize == '0' "> -->
                            <!-- <span>{{detail.showFlow}}</span> -->
                            <!-- <i v-if="detail.periodStr">/{{ detail.periodStr }}</i> -->
                    <!-- </van-cell> -->
                    
                    <!-- 老业务逻辑展示套餐周期 -->
                    <!-- <van-cell v-if="detail.period" :title="$t('packages.detail.cell_period')" :value="detail.periodText"></van-cell> -->
                    <!-- 连续畅享  展示套餐周期 -->
                    <!-- <van-cell value-class="flex2" v-if="detail.showPeriod" :title="$t('packages.detail.cell_period')" :value="detail.showPeriod"></van-cell> -->
                <!-- </div> -->
            </div>
            <div class="package-show-promotion" v-if="detail.show_Promotion">
                <div class="box-title">{{ $t('packages_detail_promotion') }}<i class="icon_more" @click="showPromotionPopup = true">...</i></div>
                <div class="package-desc" v-for="(item, index) in detail.PromotionValue" :key="index">
                    <van-cell :icon="item.show_Promotion_icon + ' iconSize' " :title="item.show_Promotion_name" ></van-cell>
                </div>
            </div>

            <!-- <div v-if="isShowCountBox" class="package-buy-quantity">
                <van-cell :title="$t('packages.detail.buy_quantity')">
                    <template>
                        <van-stepper v-model="quantity" theme="round" disable-input min="1" :max="maxQuantity" />
                    </template>
                </van-cell>
            </div> -->

                
            <div class="package-choose-option se_package_option" v-if="continue_html">
                 <div class="continue_mo" :class="{ 'active': continuePkgData.select}" v-html="this.continue_html" @click="swithPkg(0,continuePkgData)"> </div>
                 <div class="normal_mo" :class="{ 'active': normalPkgData.select}" v-if="normalPkgData"  @click="swithPkg(1,normalPkgData)">
                     <p class="se_title">{{normalPkgData.period}} {{normalPkgData.periodTxt}}</p>
                      <p class="se_package_price" v-text="normalPkgData.showPrice"></p>
                 </div>
            </div>


            <!-- <div class="package-use-area">
                <div class="box-title">
                    <span>{{ $t('packages.detail.use_area') }}</span>
                    <van-icon :name="iconName" class="toggle-btn" @click="showMoreFun" />
                </div>
                <div class="package-use-area-detail" :class="{'van-multi-ellipsis--l3': !showMore}" v-html="detail.mccListText||showAreaList||mccListText"></div>
            </div> -->
            <div class="package-use-intro" v-show="detail.showUserDetail">
                <div class="box-title">{{ $t('digital.detail.describe') }}</div>
                <div class="package-desc" v-html="detail.showUserDetail" ></div>
            </div>
        </div>

        <div class="bottom-fixed-box van-hairline--top">
            <span class="total-amount">{{ totalAmount }}</span>
            <div class="btn" @click="goSettlement_page">{{ $t('packages.detail.buy_btn') }}</div>
        </div>

        <van-popup v-model="showPromotionPopup" 
        round closeable position="bottom"
        :overlay-style="{background:'rgba(0, 0, 0, 0.5)'}"
        :close-on-click-overlay="false"
        class="icon_popup"
        
        :style="{ 'max-height': '80%','min-height': '38%' }">
            <div class="package-show-promotion bottomPopup" v-if="detail.show_Promotion">
                <div class="box-title">{{ $t('packages_detail_promotion') }}</div>
                <div class="package-desc" v-for="(item, index) in detail.PromotionValue" :key="index">
                    <van-cell :icon="item.show_Promotion_icon + ' iconSize' " :title="item.show_Promotion_name" :label="item.show_Promotion_description" ></van-cell>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>    
    //import {  keepTwodecimalFull, keepTwodecimalFixed } from '../../utils/util'
    import { Popup } from 'vant';
    import { keepTwodecimalFixed } from '../../utils/util'
    import { pay as payFun } from '../pay/pay'
    import cookie from '../../utils/cookie'
    import baseUtils from "@/utils/baseUtils"
    import { Swipe, SwipeItem, ImagePreview } from 'vant';

    const SymbolMap = {
        'zh-CN': ', ',
        'zh-TW': ', ',
        'en-US': ', ',
        'ja-JP': ', ',
    };

    export default {
        name: 'PackageDetail',        
        data() {
            return {            
                urlParams: {},
                detail: {},
                showMore: false, // 是否显示全部的“适用区域”
                headerBgImgStyle: { // 根据详情里的 goodsType来判断使用的背景图片
                    //backgroundImage: `url(${require('../../assets/imgs/packages/package_bttc.jpg')})`
                },
                quantity: 1, // 购买数量
                maxQuantity: 1, // 最大购买梳理
                isShowCountBox: false, // 是否显示购买数量栏目
                totalAmount: 0,
                mccListText: '',
                showAreaList:'',
                continuePkgData:{},
                normalPkgData:{},
                continue_html:'',
                showPromotionPopup:false,
                imageList: [], // 皮肤轮播图列表
            }
        },
        components: {
            vanSwipe: Swipe,
            vanSwipeItem: SwipeItem
        },
        computed: {
            iconName() {
                return this.showMore ? 'arrow-up': 'arrow-down'
            }
        },
        watch: {
            quantity() {
                this.calTotalAmount();
            }
        },
        mounted() {            
            this.urlParams = this.$route.query;
            // this.genHeaderBgImgStyle();                     
            this.getDetail();
            //this.getCountryInfo();
        },                     
        methods: {
            swithPkg(type,data){
                let isLxcx ;
                let selectPackage ;
                let that =this;
                if(type==0){
                     isLxcx  = true ;
                     this.continuePkgData.select = true ;
                     this.normalPkgData.select = false ;
                }else{
                     isLxcx  = false ;
                     this.continuePkgData.select = false ;
                     this.normalPkgData.select = true ; 
                }

                this.detail = data;
                selectPackage = this.detail.goodsId;
                this.calTotalAmount();
                
                try{
                    let data_package = {
                        selectPackage:selectPackage,
                        isLxcx:isLxcx,
                        data:{}
                    }
                     data_package.data[that.continuePkgData.goodsId] = JSON.stringify(this.continuePkgData);
                     data_package.data[that.normalPkgData.goodsId] = JSON.stringify(this.normalPkgData);
                    sessionStorage.setItem('data_info',JSON.stringify(data_package));
                }catch(e){
                    let data_package = '{"selectPackage":"'+selectPackage+'","isLxcx":'+isLxcx+',"data":['+JSON.stringify(this.continuePkgData)+','+JSON.stringify(this.normalPkgData)+']}';
                    sessionStorage.setItem('data_info',JSON.stringify(data_package));
                }
            },
            // 是否显示购买天数栏目
            isShowCountBoxHandler(item) {                
                try {
                    if(item.attrMap.maxCount && item.attrMap.maxCount > 1) {                        
                        this.isShowCountBox = true;
                        this.maxQuantity = item.attrMap.maxCount;                        
                    }
                } catch(err) {
                    this.isShowCountBox = false
                }
            },            
            // 收起和展开使用区域内容
            showMoreFun() {
                this.showMore = !this.showMore
            },
            goBack() {
                if(this.$route.query.souce === '扫码跳转') {
                    this.$router.push({
                        name: 'DigitalList'
                    })
                } else {
                    this.$router.go(-1);
                }
            },
            // 预览图片
            handlerImagePreview(list,index) {
                return
                ImagePreview({
                    images: list,
                    startPosition: index,
                    closeable: true,
                    loop: false
                })
            },
            // 生成订单
            async createOrder(payMethod='ACCOUNT_AMOUNT') {
                let orderObj = {},
                    channelType = this.$APP_CONFIG.request.channelType;
                let params = {                    
                    channelType,
                    orderType: 'BUYPKG',
                    currencyType: this.detail.currencyType,
                    goodsList: [{
                        goodsId: this.detail.goodsId,
                        quanity: this.quantity,
                        effectiveTime: 0,
                        expireTime: 0
                    }],
                    orderMark: '',
                    payMethod,
                    payAgreeFlag: 0
                };

                // 为家庭组下的生成订单
                if(sessionStorage.getItem('Module_Bind_Group') === 'true'){
                    params.imei = JSON.parse(sessionStorage.getItem('urlData') || '{}')?.imei
                }

                await this.$http.post({
                    url: '/bss/app/order/CreateOrder',
                    data: {
                        ...params
                    }
                }).then(res => {
                    if(res.data && res.data.orderSN) {
                        orderObj = res.data;
                    }
                }).catch(err => {                    
                    this.$toast(err);
                });

                return orderObj;
            },
            //要输入优惠券重新进入新页面
            goSettlement_page(){
                this.$router.push({
                    name: 'settlement',
                    query: {
                        ...this.$route.query,
                        quantity: this.quantity
                    }                 
                });
                
                // 神策-点击购买套餐按钮
                this.$sensors.track('WebDataPackageBuyClick', {
                    data_package_code:this.detail.goodsCode,
                    data_package_name:this.detail.goodsName,
                    data_package_type: '数字服务',
                    data_package_quantity: this.quantity,
                    data_package_amount:+this.detail.goodsPrice / 100,
                    monetary_unit:this.detail.currencyType,
                    effective_days_num:this.detail.periodUnit === 'DAY' ? +this.detail.period : +this.detail.period * 30,
                });
            },
            // 点击订购按钮
            async goPayment() {
                /*
                this.$router.push({
                    name: 'PackageBuyConfirm',
                    query: {
                        goodsCode: this.detail.goodsCode,
                        quantity: this.quantity
                    }                 
                });
                */
               // 先要生成订单
                let orderData = await this.createOrder();
                // 如果创建订单一些数据没有拿到则返回
                if(!orderData.orderSN) {
                    this.$toast(this.$t('packages.confirm.create_order_error'));
                    return;
                }

                // 去收银台支付
                payFun({
                    orderSn: orderData.orderSN,
                    totalAmount: orderData.amount,
                    currencyCode: this.detail.currencyType,
                    orderDesc: this.detail.goodsName,
                    orderSubject: this.detail.goodsName
                });
            },
            calTotalAmount() {
                let price = this.detail.goodsPrice * this.quantity;
                if(this.detail.discountPrice){
                    price = this.detail.discountPrice * this.quantity;
                }
                this.totalAmount = this.doPriceStyle(this.detail, price)
            },
            // 赋值顶部背景图片
            genHeaderBgImgStyle() {                        
                if(this.urlParams.goodsType == 'PKAG') {
                    this.$set(this.headerBgImgStyle, 'backgroundImage', `url(${require('../../assets/imgs/packages/flowpackage.jpg')})`);
                } else {
                    this.$set(this.headerBgImgStyle, 'backgroundImage', `url(${require('../../assets/imgs/packages/package_bttc.jpg')})`);                    
                }
            },
            // 获取流量套餐详情
            getDetail() {
                    let url = '/bss/app/noauth/QueryOfferList',
                    reqParams = {
                        channelType: this.$APP_CONFIG.request.channelType,
                        goodsCode: this.urlParams.goodsCode || this.$route.query.goodsCode,
                        perPageCount: 1500,  
                        queryPromotionFlag: true,
                        queryLimitFlag: true,
                        categoryCode:"DIGITAL_PRODUCTS",
                        goodsExtendAttrs:["hideFlowSize","detailRemark","detailImage",'iconImage','listImage','listImageSquare'] // detailRemark 获取扩展属性
                    };

                    this.$http.post({
                        url,
                        data: {
                            ...reqParams
                        }
                    })
                    .then(res => {
                        if(res.data && res.data.dataList && res.data.dataList.length > 0) {
                            let dataList = res.data.dataList;
                            if(this.$route.query.relationCode){
                                dataList = dataList.filter(item => item.attrMap?.relationCode === this.$route.query.relationCode);
                            }
                            this.initData(dataList);

                            // 
                            this.$nextTick(() => {
                                this.setImageHeight();
                            })

                            let goods = dataList[0];
                            let day_num = goods.periodUnit === 'DAY' ? +goods.period : +goods.period * 30;
                            // 神策-浏览套餐详情
                            this.$sensors.track('WebDataPackageDetail', {
                                data_package_detail_souce: this.$route.query.souce,
                                data_package_code: goods.goodsCode,
                                data_package_name: goods.goodsName,
                                data_package_amount: +goods.goodsPrice / 100,
                                data_num:goods.flowByte,
                                effective_days_num:day_num,
                                monetary_unit:goods.currencyType,
                            });
                        } else {
                            this.$router.push({
                                name: 'LoadFail',
                                query: {
                                    url: window.location.href
                                }
                            })
                        }
                    }).catch(err => {
                        this.$toast(err);
                        console.log(err);
                        window.setTimeout(() => {
                            this.$router.push({
                                name: 'LoadFail',
                                query: {
                                    url: window.location.href
                                }
                            })
                        }, 2000);
                    });
            },
            async initData(list) {
                let that = this;
                this.detail = list[0];
                this.detail.goodsPrice = +this.detail.goodsPrice + '';                       
                try { 
                    this.isShowCountBoxHandler(this.detail);

                    this.detail.mccList = this.detail.mccList.filter(mcc => {                        
                        if(mcc) return mcc
                    });

                    let high_speed_text = this.genHighSeepText(this.detail);
                    
                    await that.handlePackage(that.detail, high_speed_text );

                    this.calTotalAmount();
                    this.getMccListText();
                    that.goodsExtendAttrs(that.detail,that.detail);
                    this.getPromotion(list[0].goodsCode);
                    // 获取皮肤详情图片
                    this.setTopImageList(list[0]);
                } catch(err) {
                    console.log('initData 初始化异常',err);
                    this.$toast(err);
                }
            },
            // 皮肤详情图片
            setTopImageList(goodsDetail) {
                let list = goodsDetail.extendValVos.filter(item => {
                    return item.attrCode === 'detailImage'
                }).flatMap(item => {
                    return item.attrValueList
                }) || [];
                // 
                this.imageList = [...list].slice(0,1)
            },
            // 设置图片高度
            setImageHeight() {
                const ratio = 336 / 184; // 336:184 是图片的宽高比
                let img = document.querySelector('.package-detail-header');
                if(img) {
                    img.style.height = `${img.offsetWidth / ratio}px`;
                }
            },
            async handlePackage( tempData , high_speed_text ){
                let that = this,flow;

                //按照老业务展示流量大小
                tempData.showFlow = this.doFlowByteText(tempData) + ' ' + high_speed_text;
                tempData.showPeriod = this.getValidityPeriod(tempData);
                //元转分 方法统一使用该项目处理方案
                // tempData.showPrice = tempData.currencyType + ' ' + this.commonHelper.FenToYuan(tempData.goodsPrice)
                tempData.showPrice = that.doPriceStyle(tempData, tempData.goodsPrice);
                tempData.showUserDetail = tempData.attrMap.pkDesc;
                tempData.showIsInfinite = tempData.attrMap.infiniFlag;
                this.mccLength = tempData.iso2List?.length;
                tempData.periodStr = (tempData.billingInfos && tempData.billingInfos[0]) ?  this.moOrDay(tempData.billingInfos[0]) : '' ;

                //复用流量商城原始方法获取地区
                this.showAreaList = tempData.mccList.join(SymbolMap[cookie.getCookie('langType')]||', ');

                //连续畅销
                tempData.firstPrice = '';
                tempData.oringPrice = '';
                
                //营销活动划线价格
                if(tempData.discountPrice){

                    tempData.showPrice = that.doPriceStyle(tempData, tempData.discountPrice);
                    //tempData.goodsPrice 此处单位和货币展示不处理，由模板处理
                    tempData.oringPrice = tempData.goodsPrice; 
                }
                if(tempData.categoryCode === "LXCX"){
                    this.normalPkgData = await this.getAgreePackage();

                    let preCalcOrder ;

                    
                    
                    if(cookie.getCookie("access_token") && localStorage.getItem('loginCustomerId') ){
                        preCalcOrder = await this.preCalcOrder(tempData);
                    }

                    let html = '' ;
                    let selectPackage ;
                    let isLxcx ;
                    //处理连续包月套餐
                    tempData.select = true ;
                    tempData.periodTxt = tempData.periodUnit == 'MONTH' ? this.$t('packages.continuousMonth') : this.$t('packages.continuousDay');
                    html += '<p class="se_title">' + tempData.periodTxt +'</p>';
                    if(tempData.deductionInfo){
                        tempData.firstPrice = tempData.deductionInfo.autoRenewFirstPrice < tempData.deductionInfo.autoRenewPrice ?tempData.deductionInfo.autoRenewFirstPrice : '';
                        tempData.oringPrice =  tempData.goodsPrice ;
                        tempData.goodsPrice = tempData.deductionInfo.autoRenewPrice < parseInt(tempData.goodsPrice) ? tempData.deductionInfo.autoRenewPrice : tempData.goodsPrice ;
                        tempData.goodsPrice = preCalcOrder ? preCalcOrder.data.payPrice : tempData.goodsPrice ;
                        // tempData.showPrice = tempData.currencyType + ' ' + this.commonHelper.FenToYuan(tempData.goodsPrice);

                        tempData.showPrice = that.doPriceStyle(tempData, tempData.goodsPrice);
                        if(tempData.firstPrice){
                            //有预计算就显示预计算价格
                            let realprice = preCalcOrder ? that.doPriceStyle(tempData,preCalcOrder.
                                data.payPrice) : that.doPriceStyle(tempData,tempData.firstPrice) ;

                            html += '<p class="se_content">'+that.$t('orderTips.First_charge_discount') + '</p>';

                            html = html.replace('%@firstMoney',that.doPriceStyle(tempData,tempData.firstPrice)).replace('%@money',that.doPriceStyle(tempData,tempData.deductionInfo.autoRenewPrice)).replace(new RegExp('%@periodSymbol',"g"),tempData.periodStr);
                            
                            html += '<p class="se_package_price">'+realprice+'   <i class="oprice">'+that.doPriceStyle(tempData,tempData.oringPrice) +'</i></p>';
                            tempData.firstShowPrice =  realprice;
                        }else{ //不存在首次优惠则计算和普通包月差价
                            if(tempData.oringPrice > tempData.goodsPrice){
                                tempData.savePrice = parseInt(tempData.oringPrice) - parseInt(tempData.goodsPrice);

                                html += '<p class="se_content">'+that.$t('orderTips.Monthly_discount') + '</p>';

                                html = html.replace('%@saveMoney',that.doPriceStyle(tempData,tempData.savePrice)).replace('%@period',tempData.periodStr);

                                html += '<p class="se_package_price">'+that.doPriceStyle(tempData,tempData.goodsPrice)+'  <i class="oprice">'+that.doPriceStyle(tempData,tempData.oringPrice)+'</i></p>';
                            }else{
                                html += '<p class="se_content">'+ that.$t('detail_se_content') + '</p>';
                                html += '<p class="se_package_price">'+that.doPriceStyle(tempData,tempData.goodsPrice)+'</p>';
                            }
                        }   
                    }else{

                        html += '<p class="se_content">' + that.$t('detail_se_content') +'</p>';
                        html += '<p class="se_package_price">'+that.doPriceStyle(tempData,tempData.goodsPrice)+'</p>';
                    }
                    
                    this.continue_html = html;
                    this.continuePkgData = tempData;
                    isLxcx  = true ; //默认选择
                    selectPackage = tempData.goodsId;
                    
                    try{
                        let data_package = {
                            selectPackage:selectPackage,
                            isLxcx:isLxcx,
                            data:{}
                        }
                        if(that.continuePkgData.goodsId){
                            data_package.data[that.continuePkgData.goodsId] = JSON.stringify(this.continuePkgData);   
                        }
                         
                         if(that.normalPkgData && that.normalPkgData.goodsId){
                            data_package.data[that.normalPkgData.goodsId] = JSON.stringify(this.normalPkgData);   
                         }
                         
                        
                        sessionStorage.setItem('data_info',JSON.stringify(data_package));
                    }catch(e){
                        let data_package = '{"selectPackage":"'+selectPackage+'","isLxcx":'+isLxcx+',"data":['+JSON.stringify(this.continuePkgData)+','+JSON.stringify(this.normalPkgData)+']}';
                        sessionStorage.setItem('data_info',data_package);
                        console.log('数据异常,请仔细检查')
                    }

                }else{
                    let isLxcx  = false ; //默认选择
                    let selectPackage = tempData.goodsId;
                    
                    try{
                        let data_package = {
                            selectPackage:selectPackage,
                            isLxcx:isLxcx,
                            data:{}
                        }
                        if(tempData.goodsId){
                            data_package.data[selectPackage] = JSON.stringify(tempData);   
                        }
                         
                        sessionStorage.setItem('data_info',JSON.stringify(data_package));
                    }catch(e){
                        let data_package = '{"selectPackage":"'+
                                            selectPackage+
                                            '","isLxcx":'+
                                            isLxcx+
                                            ',"data":['+
                                            JSON.stringify(this.normalPkgData)+
                                            ']}';
                        sessionStorage.setItem('data_info',data_package);
                        console.log('数据异常,请仔细检查')
                    }
                }
                
                sessionStorage.setItem('data_coverage',tempData.iso2List);
                //this.packageData 已存在，在此项目使用 that.detail
                //利用对象的引用值更改赋值
                //this.packageData = tempData;

            },
            getPromotion(goodsCode){
                let that = this;
                let actDetailList = { //营销活动
                    goodsCode:goodsCode || this.urlParams.goodsCode,
                    params:{
                        "queryVipDayFlag":false,
                        "supportExclusive":true
                    }
                }
                that.$http.post(this.$api.getPromotion, actDetailList)
                .then(res => {
                        if(res.data && res.data.length > 0) {
                            that.$nextTick(() => {
                                that.$set(that.detail, 'show_Promotion', true);
                            });
                            
                            for (let a in res.data) {
                                
                                that.detail.PromotionValue = [];
                                that.detail.PromotionValue[a] ={};
                                if(res.data[a].actionType[0] =='P05') {

                                    that.detail.PromotionValue[a].show_Promotion_icon = 'sale';
                                }else if(res.data[a].actionType[0] == 'P01' || res.data[a].actionType[0] == 'P03') {
                                    that.detail.PromotionValue[a].show_Promotion_icon = 'discount';
                                }else if(res.data[a].actionType[0] == 'P02' || res.data[a].actionType[0] == 'P04') {
                                    that.detail.PromotionValue[a].show_Promotion_icon = 'deduction';
                                }else {
                                    that.detail.PromotionValue[a].show_Promotion_icon = 'gift';
                                }
                                
                                
                                let actLanguageList = res.data[a].actLanguageList;
                                // 使用 find 方法找到 languageType 为 "en-US" 的对象
                                const enUsLanguageItem = actLanguageList.find(item => item.languageType == "en-US");
                                console.log(cookie.getCookie('langType'));
                                const langType_UsLanguageItem = actLanguageList.find(item => item.languageType == cookie.getCookie('langType'));
                                 
                                // 检查是否找到了对象，并获取其 name 值
                                if (langType_UsLanguageItem) {
                                    that.detail.PromotionValue[a].show_Promotion_name = langType_UsLanguageItem.name;
                                    that.detail.PromotionValue[a].show_Promotion_description = langType_UsLanguageItem.description && langType_UsLanguageItem.description || '';
                                } else {
                                    that.detail.PromotionValue[a].show_Promotion_name = enUsLanguageItem.name;
                                    that.detail.PromotionValue[a].show_Promotion_description = enUsLanguageItem.description && enUsLanguageItem.description || '';
                                }

                            }
                            sessionStorage.setItem('data_promotion',JSON.stringify(that.detail));
                        } else {
                            sessionStorage.removeItem('data_promotion');
                        }
                    }).catch(err => {
                        console.log(err);
                    });
            },
            //连续包月增加--20241205--start
            getValidityPeriod (a) {
                // 有效期
                let periodTxt = '';

                if (a.attrMap.expType && (a.attrMap.expType == 'CURRENT_MONTH' || a.attrMap.expType == 'CURRENT_DAY')) {
                    periodTxt = this.getTypeOfFailures(a);      // 失效类型
                } else {
                    if (a.period == null || a.period == '') {
                        periodTxt = '';
                    } else {
                        let actionType = this.getEffectiveType (a);     // 生效类型
                        periodTxt = a.period +' '+ this.getUnitOfTime (a.periodUnit, a.period) + ' ' + actionType;
                    }
                }
                return periodTxt;
            },
            getTypeOfFailures (a) {
                // 失效类型
                let actionType = '';

                if (a != null && a != '' && a.attrMap.expType) {
                    if (a.attrMap.expType == 'CURRENT_MONTH') {
                        actionType = this.$t('packages.month_invalid');
                    } else if (a.attrMap.expType == 'CURRENT_DAY') {
                        actionType = this.$t('packages.day_invalid');
                    } else if (a.attrMap.expType == 'DEFAULT') {
                        actionType = '';
                    } else {
                        actionType = '';
                    }
                }
                return  actionType;
            },
            getEffectiveType (a) {
                // 生效类型
                let actionType = '';

                if (a != null && a != '' && a.attrMap.effType) {
                    if (a.attrMap.effType == 'IMMEDIATELY') {
                        a.period == null || a.period == '' ? actionType = this.$t('packages.immediate_valid') : actionType = '('+ this.$t('packages.immediate_valid') +')'

                    } else if (a.attrMap.effType == 'MORROW') {
                        a.period == null || a.period == '' ? actionType = this.$t('packages.tomorrow_day_valid') : actionType = '('+ this.$t('packages.tomorrow_day_valid') +')';

                    } else if (a.attrMap.effType == 'USER_DEFINED') {
                        actionType = '';

                    } else if (a.attrMap.effType == 'NEXT_MONTH') {
                        a.period == null || a.period == '' ? actionType = this.$t('packages.tomorrow_month_valid') : actionType = '('+ this.$t('packages.tomorrow_month_valid') +')';

                    } else {
                        actionType = '';
                    }
                }
                return actionType;
            },
            getUnitOfTime (a, b) {
                let unit = a;

                if (unit == 'DAY' || unit == null || unit == '') {
                    if (parseInt(b) < 2 || b == null || b =='') {
                        unit = this.$t('packages.periodUnit.day');
                    } else {
                        unit = this.$t('packages.periodUnits.day');
                    }
                } else if (unit == 'MONTH') {
                    if (parseInt(b) < 2 || b == null || b =='') {
                        unit = this.$t('packages.periodUnit.month');
                    } else {
                        unit = this.$t('packages.periodUnits.month');
                    }
                }
                return unit;
            },
            //moOrDay 的功能 与genHighSeepText 一致
            //新老版本使用方法不同，保留genHighSeepText方法 
            moOrDay(data){
                var str = "";
                if(data.periodUnit == 1){
                if(data.period>1){
                    str = data.period+this.$t('packages.periodUnits.day');
                }else{
                    str = this.$t('packages.periodUnit.day');
                }

                }else if(data.periodUnit == 2 || data.periodUnit == 12){
                    if(data.period>1){
                        str = data.period+this.$t('packages.periodUnitsSimp.month');
                    }else{
                        str = this.$t('packages.periodUnitSimp.month');
                    }
                }else if(data.periodUnit == 0){
                    if(data.period>1){
                        str = data.period+this.$t('packages.periodUnits.hour');
                    }else{
                        str = this.$t('packages.periodUnit.hour');
                    }
                }else if(data.periodUnit == 3){
                    if(data.period>1){
                        str = data.period+this.$t('packages.periodUnits.year');
                    }else{
                        str = this.$t('packages.periodUnit.year');
                    }
                }else{
                    str = '';
                }
                return str;
            
            },
            preCalcOrder(data){
                let that = this;
                let package_param = {
                    userCode: JSON.parse(localStorage.getItem("userInfo"))['userCode'],
                    payMethod: "ACCOUNT_AMOUNT",
                    promotionCode:"",
                    payCurrencyType: data.currencyType,
                    payAgreeFlag: 1,
                    goodsList: [{goodsId:data.goodsId,quanity:that.quantity}]
                };
                
                return this.$http.post(this.$api.preCalcOrder, package_param);
            },
            getAgreePackage () {
                let that =this;
                let package_param = {
                    baseCode: this.urlParams.goodsCode,
                    sortFlag: 1,
                    realType: "AGREE_RECOMMOND",
                    queryLimitFlag:true
                };
                return that.$http.post(this.$api.getAgreePackage, package_param).then(response=>{
                    let tempNor =  response.data.dataList[0];
                    let flow;
                     if (!tempNor) {
                        return;
                    }
                    if (tempNor.categoryCode === "BTTC" || 
                        tempNor.categoryCode === "BYTC" ||
                        tempNor.categoryCode === "SWBY" || 
                        tempNor.categoryCode === "CXTC" || 
                        tempNor.categoryCode === "ZLTC") {
                        if(!!(tempNor.flowByte) && tempNor.flowByte>0){
                            flow = baseUtils.trafficRules(tempNor.flowByte)+" "+this.$t('packages.high_speed_text');
                        }else{
                            flow = this.$t('packages.infiniteFlow');
                        }
                    } else {
                        if (tempNor.goodsType == 'DISC'){
                            flow = baseUtils.trafficRules(tempNor.flowByte)+" "+this.$t('packages.highSpeedTraffic');    
                        }else{
                            flow = baseUtils.trafficRules(tempNor.flowByte);
                        }
                        
                    }
                    tempNor.select = false;
                    tempNor.showFlow = flow;
                    tempNor.showPeriod = this.getValidityPeriod(tempNor);

                    tempNor.showPrice = this.doPriceStyle(tempNor, tempNor.goodsPrice);

                    
                    tempNor.showUserDetail = tempNor.attrMap.pkDesc;
                    tempNor.periodTxt = tempNor.periodUnit == 'MONTH' ? (tempNor.period > 1 ? this.$t('packages.periodUnits.month') : this.$t('packages.periodUnit.month')) : (tempNor.period > 1 ? this.$t('packages.periodUnits.day') : this.$t('packages.periodUnit.day')) ;
                    tempNor.periodStr = tempNor.goodsType==='DISC' && tempNor.billingInfos ?  this.moOrDay(tempNor.billingInfos[0]) : '' ; ; 
                    return tempNor;
                });
            },
            //连续包月增加--20241205--end
            getMccListText() {
                this.getCoverListMixin().then(res => {                    
                    let mccMap = {};
                    this.detail.iso2List?.forEach(iso => {
                        res.data.forEach(obj => {
                            if(iso == obj.iso2 && obj.continent) {
                                if(mccMap[obj.continent]) {
                                    mccMap[obj.continent].push(obj.countryName)
                                } else {
                                    mccMap[obj.continent] = [];
                                    mccMap[obj.continent].push(obj.countryName)
                                }
                            }
                        })
                    });                    
                    let text = '';
                    Object.keys(mccMap).forEach(key => {
                        text += `${key}：${mccMap[key].join('、')}<br/>`
                    });
                    this.mccListText = text;
                }).catch(err => {
                    this.$toast(err)
                })
            },
            genHighSeepText(item) {
                if (item.goodsType == 'DISC') { // unlimited packages
                    if (['BYTC', 'SWBY', 'BTTC', 'LXCX'].includes(item.categoryCode)) {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                        // 0为按小时取，1为按天取，2为按月取，3为按年取，12为动态月也是按月取同2
                        // 有限期和限速规则一样，显示高速流量
                        let billInfo = item.billingInfos;
                        if(billInfo && billInfo.length > 0) {
                            if(billInfo[0].periodUnit === 0) {
                                if(item.period == billInfo[0].period && item.periodUnit == 'HOUR') {
                                    item.high_speed_text = this.$t('packages.high_speed_text');
                                } else {
                                    if(billInfo[0].period > 1) {
                                        item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.hour')
                                    } else {
                                        item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.hour')
                                    }
                                }
                            } else if(billInfo[0].periodUnit === 1) {
                                if(item.period == billInfo[0].period && item.periodUnit == 'DAY') {
                                item.high_speed_text = this.$t('packages.high_speed_text');
                                } else {
                                    if(billInfo[0].period > 1) {
                                        item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.day')
                                    } else {
                                        item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.day')
                                    }
                                }

                            } else if(billInfo[0].periodUnit === 2 || billInfo[0].periodUnit === 12) {
                                if(item.period == billInfo[0].period && item.periodUnit == 'MONTH') {
                                    item.high_speed_text = this.$t('packages.high_speed_text');
                                } else {
                                    if(billInfo[0].period > 1) {
                                        item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.month')
                                    } else {
                                        item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.month')
                                    }
                                }
                            } else if(billInfo[0].periodUnit === 3) {
                                if(item.period == billInfo[0].period && item.periodUnit == 'YEAR') {
                                    item.high_speed_text = this.$t('packages.high_speed_text');
                                } else {
                                    if(billInfo[0].period > 1) {
                                        item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.year')
                                    } else {
                                        item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.year')
                                    }
                                }
                            }
                        }
                    }
                }

                return item.high_speed_text ? item.high_speed_text : '';
            },
            doFlowByteText(item) {
                let flowText = '0MB',
                    flowValue = item.billingInfos && item.billingInfos.length ? item.billingInfos[0].flow : (item.flowByte ? item.flowByte : 0);                    

                if(flowValue >= 1000) {
                    let flow = flowValue/1024;
                    // 判断是不是整数
                    if(Math.floor(flow) === flow) {
                        flowText = `${flow}GB`;
                    } else {
                        let langType = cookie.getCookie('langType')
                        // 部分欧洲国家小数点采取 ， 形式
                        let country = ['es-ES','pt-PT','de-DE','fr-FR']; 
                        let showFlow = keepTwodecimalFixed(flow)
                        if(country.includes(langType)){
                            showFlow = showFlow.replace('.',',')
                        }
                        flowText = `${showFlow}GB`;
                    }
                } else {
                    flowText = `${flowValue}MB`;
                }

                return flowText;        
            },
            doPriceStyle(item, price) {
                //price = keepTwodecimalFull(price/100);
                //return `${item.currencyType} ${price}`;
                return this.globalPriceFormat(item.currencyType, price);                
            },
            goodsExtendAttrs(item,{extendValVos}){
                if(extendValVos && extendValVos.length){
                    let _item = arguments[0];
                    extendValVos.forEach( _goodsExtendAttrsItem => {  
                        // 获取 attrValueList 数组  
                        const attrValueList = _goodsExtendAttrsItem.attrValueList;  
                          
                        // 判断attrValueList数组并获取值  
                        const getValue= attrValueList && attrValueList[0];

                        //a_hideFlowSize
                        item['a_' + _goodsExtendAttrsItem.attrCode] = attrValueList;

                        //a_getValue_hideFlowSize
                        item['a_getValue_' + _goodsExtendAttrsItem.attrCode] = getValue;

                    });
                    return _item;
                }
            },
        }
    }
</script>

<style lang="less" scoped>    
    @New_assets: "../../assets";
    .package-detail {
        background-color: #f2f2f2;
        min-height: 100vh;
        padding-bottom: 50px;

        .package-detail-header {
            // min-height: 200px;    
            background-size: 100%;
            position: relative;

            .package-detail-header-box {
                position: absolute;
            }

            .package-detail-swiper {
                width: 100%;
                height: 200px;
            }
        }

        .box() {
            border-radius: 8px;
            background-color: #fff;
        }

        .package-detail-box {        
            margin: 0 8px;        
            position: relative;
            // top: -22px;   
            .box-title {
                font-size: 16px;
                margin-bottom: 16px;
                position: relative;
                .toggle-btn {
                    color: #999;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            .package-buy-quantity {
                .box();
                margin-top: 8px;
                padding: 10px 0px;
            }     
            .package-base-info {  
                .info-box {
                    margin-top: 15px;
                    padding-top: 10px;                
                }   
                .van-cell {
                    padding: 2px 0;
                    font-size: 14px;
                }
                .van-cell::after {
                    border: none;
                }                   
                padding: 20px 16px;
                .box();
                .goods-name {
                    font-size: 18px;
                }
                .goods-price {
                    font-family: Roboto-Medium;
                    font-size: 18px;
                    margin-top: 15px;
                    color: #F74E4E;
                }
            }
            .package-use-area {
                margin-top: 8px;
                padding: 20px 16px;
                .box();            
                font-size: 14px;
                .package-use-area-detail {
                    color: #2A2A2A;
                }
            }
            .package-use-intro {
                margin-top: 8px;            
                padding: 20px 16px;
                .box();            
                font-size: 14px;
                .package-desc {
                    color: #2A2A2A;
                }
            }
            .package-choose-option {
                margin-top: 8px;
                .box();            
                font-size: 14px;
            }
            
        }
        .package-show-promotion{
            .package-detail-box .package-use-intro();  
            .box-title {
                margin-bottom: 0.1rem;
            }
            padding-bottom: 0.28rem;
            .van-cell{
                padding-left: 0;
            }
            .iconSize{
                background-size: contain;
                height: 0.6rem;
                width: 0.65rem;
                background-repeat: no-repeat;
                background-position: left center;
                position: relative;
                top: .01rem;
            }
            .van-icon-deduction{
                background-image:url("@{New_assets}/imgs/packages/deduction.png");
            }
            .van-icon-sale{
                background-image:url("@{New_assets}/imgs/packages/sale.png");
            }
            .van-icon-discount{
                background-image:url("@{New_assets}/imgs/packages/discount.png");
            }
            .van-icon-gift{
                background-image:url("@{New_assets}/imgs/packages/gift.png");
            }
            .van-icon-gift:before,.van-icon-sale:before,.van-icon-discount:before{
                content: "" !important;
            }
            .van-cell__left-icon{
                margin-right: 0.2rem;
            }
            .icon_more{
                position: absolute;
                right: 0;
                top: 0;
                font-weight: bold;
                line-height: 0.25rem;
            }
            .van-cell__label{
                white-space: pre-line;
            }
        }
        .bottomPopup{
            min-height: 30%;
            .box-title{
                text-align: center;
                font-size: 18px;
                font-weight: bold;
            }
        }

        .bottom-fixed-box {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #fff;
            padding: 0 8px 0 16px;
            height: 56px;
            line-height: 56px;

            .total-amount {
                font-family: Roboto-Medium;
                font-size: 18px;                
                color: #F74E4E;
            }
            .btn {
                position: absolute;
                right: 8px;
                top: 50%;
                transform: translateY(-50%);
                height: 40px;
                line-height: 40px;
                background-color: #1e40af;
                color: #fff;
                width: 100px;
                text-align: center;
                font-size: 16px;
                border-radius: 19px;
            }
        }
    }

    html[dir="rtl"] {
        .package-detail {
            .package-detail-box { 
                .box-title {
                    .toggle-btn {
                        right: unset;
                        left: 0;
                    }
                }
                .package-base-info {  
                    .info-box {
                        .van-cell {
                            .van-cell__value {
                                text-align: left;
                            }
                        }
                    }
                }
                .package-buy-quantity {
                    .van-cell {
                        .van-cell__value {
                            text-align: left;
                        }
                    }
                }
            }
            .package-show-promotion {
                .icon_more{
                    right: unset;
                    left: 0;
                }
                .package-desc {
                    .van-cell {
                        padding-right: 0;
                        padding-left: 16px;
                        .van-icon {
                            margin-right: 0;
                            margin-left: 0.2rem;
                        }
                    }
                }
            }
            .bottom-fixed-box {
                .btn {
                    right: unset;
                    left: 8px;
                }
            }
            .icon_popup {
                .van-icon.van-popup__close-icon--top-right {
                    right: unset;
                    left: 0.444444rem;
                }
            }
        }
    }
    @assets: "../../assets";
    
    .flex2{
        flex:2;
    }
    .goods-price i.oprice {
        opacity: 0.8;
        font-size: .28rem;
        color: #999999;
        text-decoration: line-through;
    }
    .se_package_option .se_package_price {
        font-size: 0.36rem;
        color: #F74E4E;
        margin-bottom: 0.32rem;
    }
    .se_package_option .continue_mo,
    .se_package_option .normal_mo  {
        border: 0.5px solid rgba(224,224,224,1);
        padding: 0.2rem;
        border-radius: 0.08rem;
        margin: 0 0 0.4rem;
    }
    .se_package_option {
        background: #ffffff;
        border-radius: 8px;
        padding: 0.68rem 0.32rem .28rem;
        margin-top: 0.16rem;
    }
    .se_package_option .se_title{
        font-size: 0.32rem;
        color: #333333;
        margin-bottom: 0.32rem;
        font-weight: 600;
    }
    .se_package_option .continue_mo.active{
        border: 1px solid rgba(255,179,50,1);
    }
    .se_package_option .se_content{
        margin: .2rem 0;
    }
    .se_package_option .se_content{
        font-size: 0.28rem;
        color: #333333;
    }
    .se_package_price i.oprice {
        opacity: 0.8;
        font-size: .28rem;
        color: #999999;
        text-decoration: line-through;
    }
    .se_package_option .active{
        background:url("@{assets}/imgs/packages/op_selected_right.png") no-repeat rgba(255,179,50,0.10) top right;
        background-size: 0.6rem;
    }
</style>